document.addEventListener('DOMContentLoaded', function () {
  // Primera carga
  heroInit();

  // Actualizar fondo carousel en resize
  window.addEventListener('resize', heroInit);

  function heroInit() {
    const carousel = document.querySelector('.carousel');
    if (!carousel) return;

    const isMobile = window.innerWidth < 992;
    const items = document.querySelectorAll('.carousel .carousel-item');

    items.forEach(function (item) {
      const backMo = item.dataset.backgroundmobile;
      const backDesk = item.dataset.backgrounddesktop;
      const url = isMobile ? backMo : backDesk;

      if (url) {
        item.style.backgroundImage = 'url(' + url + ')';
      }
    });

    // Recargar la página cuando se cierre el modal (si existe)
    const modlHer = document.getElementById('modlHero');
    if (modlHer) {
      modlHer.addEventListener('hidden.bs.modal', function () {
        window.location.reload();
      });
    }
  }

  // Click en enlaces para abrir el modal de edición
  const editLinks = document.querySelectorAll('.post-edit-link-hero-carousel');
  editLinks.forEach(function (linkEl) {
    linkEl.addEventListener('click', function (ev) {
      ev.preventDefault();

      const url = linkEl.dataset.linkhref;
      const iframe = document.getElementById('modShowHero');
      const modalEl = document.getElementById('modlHero');
      const loader = document.querySelector('.editModalLoad');

      if (!modalEl || !iframe) return;

      // Setear URL en el iframe
      iframe.setAttribute('src', url);

      // Mostrar loader y ocultar iframe al inicio
      if (loader) loader.style.display = '';
      iframe.style.display = 'none';

      // Abrir modal con API de Bootstrap 5
      // Requiere que Bootstrap JS esté cargado y accesible como "bootstrap"
      const modalInstance = bootstrap.Modal.getOrCreateInstance(modalEl);
      modalInstance.show();

      // Tras 4s: ocultar loader y mostrar iframe
      window.setTimeout(function () {
        if (loader) loader.style.display = 'none';
        iframe.style.display = '';
      }, 4000);
    });
  });
});